import axios, { AxiosPromise } from 'axios';
import { ISite } from '../../../@types/model/masterData/site/site';
import { ISiteUpsert } from '../../../@types/model/masterData/site/siteUpsert';

export default class SiteHttpService {
    public static getSiteData() : AxiosPromise<Array<ISite>> {
        return axios.get(`${API_URL}/v1/Site/GetAllWeb`);
    }

    public static addOrUpdateSite(upsert : ISiteUpsert) : AxiosPromise<ISite> {
        return axios.post(`${API_URL}/v1/Site/Upsert`, upsert);
    }

    public static deleteSite(siteId : number) : AxiosPromise<ISite> {
        return axios.delete(`${API_URL}/v1/Site/Delete`, {
            params: { siteId },
        });
    }
}
